import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function SchoolCalendar() { 
  useEffect(() => {
    document.title = 'School Calendar -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>Academics</li>
                <li>School Calendar</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">School Calendar</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
               <div className="downloadbox">
               <p>School Calender For The  Academic Session 2025-26 </p>
                <Link to="https://webapi.entab.info/api/image/MMSKN/public/pdf/school-calendar.pdf" target="_blank">Download School Calendar </Link>
           </div>
               <div className="table-responsive">
               <table className="table maintable">
               <tbody>
               <tr>
               <td width="20%"><h5><strong>APRIL 2025</strong></h5></td>
               <td width="20%">&nbsp;</td>
               <td width="60%">&nbsp;</td>
               </tr>
               
               <tr><td>4 April</td><td>Friday</td><td>Staff Meeting</td></tr>
               <tr><td>7 April</td><td>Monday</td><td>School Re-opens for the New Session</td></tr>
               <tr><td>10 April</td><td>Thursday</td><td>Mahavir Jayanti</td></tr>
               <tr><td>14 April</td><td>Monday</td><td>Ambedkar Jayanti</td></tr>
               <tr><td>18 April</td><td>Friday</td><td>Good Friday</td></tr>
               <tr><td>30 April</td><td>Wednesday</td><td>Inter Section Creative Writing Competition (I–XII)</td></tr>
               
               <tr>
               <td width="20%"><h5><strong>MAY 2025</strong></h5></td>
               <td width="20%">&nbsp;</td>
               <td width="60%">&nbsp;</td>
               </tr>
               
               <tr><td>10 May</td><td>Saturday</td><td>Inter Section Declamation Competition (VI–XII)</td></tr>
               <tr><td>12 May</td><td>Monday</td><td>Budh Purnima</td></tr>
               <tr><td>24 May</td><td>Saturday</td><td>PTM for Classes I to VIII</td></tr>
               <tr><td>26 May – 2 July</td><td>Mon – Wed</td><td>Summer Vacation for Classes I to VIII</td></tr>
               <tr><td>31 May</td><td>Saturday</td><td>PTM for Classes IX to XII</td></tr>
               
               <tr>
               <td width="20%"><h5><strong>JUNE 2025</strong></h5></td>
               <td width="20%">&nbsp;</td>
               <td width="60%">&nbsp;</td>
               </tr>
               
               <tr><td>2 June – 2 July</td><td>Mon – Wed</td><td>Summer Vacation for Classes IX to XII</td></tr>
               
               <tr>
               <td width="20%"><h5><strong>JULY 2025</strong></h5></td>
               <td width="20%">&nbsp;</td>
               <td width="60%">&nbsp;</td>
               </tr>
               
               <tr><td>2 July</td><td>Wednesday</td><td>Staff Meeting</td></tr>
               <tr><td>3 July</td><td>Thursday</td><td>School Re-opens After Summer Break</td></tr>
               <tr><td>10 – 21 July</td><td>Thu – Mon</td><td>First Term Unit Test (I–XII)</td></tr>
               <tr><td>26 July</td><td>Saturday</td><td>PTM for Classes I to XII</td></tr>
               <tr><td>31 July</td><td>Thursday</td><td>Founder’s Day – Investiture Ceremony</td></tr>
               
               <tr>
               <td width="20%"><h5><strong>AUGUST 2025</strong></h5></td>
               <td width="20%">&nbsp;</td>
               <td width="60%">&nbsp;</td>
               </tr>
               
               <tr><td>1 – 2 August</td><td>Fri – Sat</td><td>Inter School Literary Events</td></tr>
               <tr><td>7 – 8 August</td><td>Thu – Fri</td><td>Inter School Basketball Tournament</td></tr>
               <tr><td>9 August</td><td>Saturday</td><td>Raksha Bandhan</td></tr>
               <tr><td>15 August</td><td>Friday</td><td>Independence Day</td></tr>
               <tr><td>16 August</td><td>Saturday</td><td>Janmashtami</td></tr>
               <tr><td>29 – 30 August</td><td>Fri – Sat</td><td>Inter Section Story Narration Competition (I–V)</td></tr>
               
               <tr>
               <td width="20%"><h5><strong>SEPTEMBER 2025</strong></h5></td>
               <td width="20%">&nbsp;</td>
               <td width="60%">&nbsp;</td>
               </tr>
               
               <tr><td>5 September</td><td>Friday</td><td>Teachers’ Day / Id-ul-Milad</td></tr>
               <tr><td>8 September</td><td>Monday</td><td>Hindi Diwas Celebration</td></tr>
               <tr><td>12 – 29 September</td><td>Fri – Mon</td><td>Half-Yearly Examinations</td></tr>
               <tr><td>30 September – 2 October</td><td>Tue – Thu</td><td>Dusshera Holidays</td></tr>
               
               
               <tr>
               <td width="20%"><h5><strong>October 2025 </strong></h5></td>
               <td width="20%">&nbsp;</td>
               <td width="60%">&nbsp;</td>
               </tr>
               <tr><td>02 October</td><td>Thursday</td><td>GANDHI JAYANTI</td></tr>
               <tr><td>11 October</td><td>Saturday</td><td>PTM FOR CLASSES I TO XII</td></tr>
               <tr><td>18 October</td><td>Saturday</td><td>INTER SCHOOL DANCE COMPETITION</td></tr>
               <tr><td>20–23 October</td><td>Monday–Thursday</td><td>DEEPAWALI HOLIDAYS</td></tr>
               <tr><td>31 October</td><td>Friday</td><td>INTER HOUSE SPORTS ACTIVITIES (IX – XII)</td></tr>
               
               <tr>
               <td width="20%"><h5><strong>November 2025 </strong></h5></td>
               <td width="20%">&nbsp;</td>
               <td width="60%">&nbsp;</td>
               </tr>
               <tr><td>3 November</td><td>Monday</td><td>WINTER UNIFORM TO BE WORN</td></tr>
               <tr><td>5 November</td><td>Wednesday</td><td>GURU NANAK JAYANTI</td></tr>
               <tr><td>21 November – 10 December</td><td>Friday – Wednesday</td><td>PRE-BOARD EXAM – I (X & XII)</td></tr>
               <tr><td>29 November</td><td>Saturday</td><td>INTER HOUSE SPORTS ACTIVITIES (VI – VIII)</td></tr>
               <tr><td>29 November</td><td>Saturday</td><td>INTER SCHOOL CHOIR COMPETITION</td></tr>
               
               <tr>
               <td width="20%"><h5><strong>December 2025 </strong></h5></td>
               <td width="20%">&nbsp;</td>
               <td width="60%">&nbsp;</td>
               </tr>
               <tr><td>11–22 December</td><td>Thursday–Monday</td><td>SECOND TERM UNIT TEST (I – IX & XI)</td></tr>
               <tr><td>23–27 December</td><td>Tuesday–Saturday</td><td>CHRISTMAS HOLIDAYS</td></tr>
               <tr><td>31 December</td><td>Wednesday</td><td>PTM FOR CLASSES IX to XII</td></tr>
               
               <tr>
               <td width="20%"><h5><strong>January 2026 </strong></h5></td>
               <td width="20%">&nbsp;</td>
               <td width="60%">&nbsp;</td>
               </tr>
               <tr><td>01–15 January</td><td>Thursday–Thursday</td><td>WINTER VACATION</td></tr>
               <tr><td>16 January</td><td>Friday</td><td>SCHOOL RE-OPENS AFTER WINTER VACATION</td></tr>
               <tr><td>17 January</td><td>Saturday</td><td>PTM FOR CLASSES I to VIII</td></tr>
               <tr><td>26 January</td><td>Monday</td><td>REPUBLIC DAY</td></tr>
               
               <tr>
               <td width="20%"><h5><strong>February 2026 </strong></h5></td>
               <td width="20%">&nbsp;</td>
               <td width="60%">&nbsp;</td>
               </tr>
               <tr><td>2 February</td><td>Monday</td><td>INTER HOUSE SPORTS ACTIVITIES (IV & V)</td></tr>
               <tr><td>12–28 February</td><td>Thursday–Saturday</td><td>*FINAL EXAMINATIONS BEGIN (IX & XI)</td></tr>
               <tr><td>23 February – 18 March</td><td>Monday–Wednesday</td><td>*FINAL EXAMINATIONS BEGIN (I to VIII)</td></tr>
               
               <tr>
               <td width="20%"><h5><strong>March 2026 </strong></h5></td>
               <td width="20%">&nbsp;</td>
               <td width="60%">&nbsp;</td>
               </tr>
               <tr><td>3–4 March</td><td>Tuesday–Wednesday</td><td>HOLI</td></tr>
               <tr><td>9 March</td><td>Monday</td><td>❖HOLI MELA</td></tr>
               <tr><td>21 March</td><td>Saturday</td><td># ID – UL – FITR</td></tr>
               <tr><td>26 March</td><td>Thursday</td><td>RAM NAVAMI</td></tr>
               <tr><td>31 March</td><td>Tuesday</td><td>MAHAVIR JAYANTI</td></tr>
               </tbody>
               </table>
               </div>
               </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default SchoolCalendar;
